// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownTag__root___3_Zz3"};